"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _VerifyCodeBtn = _interopRequireDefault(require("@/components/VerifyCodeBtn"));

var _index = require("@/api/user/index");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    VerifyCodeBtn: _VerifyCodeBtn.default
  },
  computed: {
    // 计算属性不可以和data属性冲名
    disabled: function disabled() {
      if (this.phone.length === 11 && this.captcha.length === 4 && this.real_name !== '' && this.identity_no !== '' && this.job_no !== '') {
        return false;
      } else {
        return true;
      }
    }
  },
  data: function data() {
    return {
      real_name: '',
      identity_no: '',
      job_no: '',
      phone: '',
      captcha: ''
    };
  },
  methods: {
    bind: function () {
      var _bind = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, phone, captcha, real_name, identity_no, job_no, ticket;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;
                phone = this.phone, captcha = this.captcha, real_name = this.real_name, identity_no = this.identity_no, job_no = this.job_no;
                ticket = this.$route.query.ticket;
                console.log({
                  real_name: real_name,
                  identity_no: identity_no,
                  phone: phone,
                  captcha: captcha,
                  ticket: ticket
                });
                _context.next = 6;
                return this.$store.dispatch('user/bind', {
                  real_name: real_name,
                  identity_no: identity_no,
                  job_no: job_no,
                  phone: phone,
                  captcha: captcha,
                  ticket: ticket
                }).then(function (res) {
                  // 获取未登录的时候跳到登录页面的redirect地址
                  var redirect = that.$route.query.redirect;

                  if (redirect) {
                    // 存在回跳地址就回跳
                    console.log(redirect);
                    console.log('存在回跳地址就回跳');
                    window.location.href = redirect;
                  } else {
                    // 否则就跳到默认的首页
                    that.$router.push({
                      name: 'Index'
                    });
                  }
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function bind() {
        return _bind.apply(this, arguments);
      }

      return bind;
    }()
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs.real_name.focus();
    });
  }
};
exports.default = _default;